import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Captura errores de render de los componentes hijos para que un fallo puntual
 * no deje el dashboard en pantalla en blanco. Es la red de seguridad: la
 * defensa principal es sanear los datos en su origen (ver coloma-mqtt.ts).
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary capturó un error de render:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-screen w-screen flex flex-col items-center justify-center bg-gray-950 text-gray-300 gap-4 px-6 text-center">
          <p className="text-lg">El panel ha encontrado un error inesperado.</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded-lg bg-cyan-700 hover:bg-cyan-600 text-white text-sm font-medium"
          >
            Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
